









import { Vue, Component, Watch } from "vue-property-decorator";

import DarkModal from "@service/components/modal/DarkModal.vue";
import DevicesTest from "./AgoraDeviceTest.vue"
import { InfoBlocksEnum } from "@service/types/InfoBlocksEnum";

@Component({
    components: { DevicesTest, DarkModal }
})

export default class AgoraDeviceTestModal extends Vue {

    show = false;

    mounted() {
        this.$parent.$on('toggleFrontBlocks', this.toggleListShowing);
    }

    destroyed() {
        this.$parent.$off('toggleFrontBlocks', this.toggleListShowing);
    }

    @Watch('routeHash')
    onRouteHashChanged(routeHash: string) {
        this.show = routeHash === this.deviceTestHash;
    }

    toggleListShowing(value: InfoBlocksEnum) {

        if(value === InfoBlocksEnum.sessions) {
            if(this.show) {
                this.close();
            }
            else {
                this.$router.push({ hash: this.deviceTestHash })
            }
        }
    }

    close() {
        this.$router.push({path: this.$route.path})
    }

    get deviceTestHash() {
        return `#${InfoBlocksEnum.deviceTest}`
    }

    get routeHash() {
        return this.$route.hash;
    }
}
